import React, { useId } from 'react'
import { AiOutlinePhone } from '@react-icons/all-files/ai/AiOutlinePhone';
import QuotePop from './DeferredQuotePopup';
import Button from './Button';
import { AiOutlineMail } from '@react-icons/all-files/ai/AiOutlineMail';
import { useDispatch } from 'react-redux';
import * as gtag from '../lib/gtag'
import { SHOW_POPUP } from '../store/slices/ui';
import AudioAction from './design-system/audio/AudioAction';
import Container from './design-system/foundations/Container';
import UiBoundary from './design-system/foundations/UiBoundary';
import styles from './NotSure.module.scss';

const NotSure = ({
  top,
  _orlando,
  legacy = false,
  eyebrow,
  title,
  description,
  quoteLabel = 'Get a Quote'
}) => {
  let dispatch = useDispatch()
  let orlando = Boolean(_orlando)
  const titleId = `catalog-support-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`
  const phoneNumber = orlando ? '407 807 0052' : '305 974 4411'
  const phoneHref = orlando ? 'tel:+14078070052' : 'tel:+13059744411'

  const openQuote = () => {
    gtag.event({ action: 'quote_click', label: 'leads', value: 3, category: 'orders' })
    dispatch(SHOW_POPUP({key: 'quote', size: 'medium', body: <QuotePop />}))
  }

  const trackCall = () => gtag.event({
    action: 'booking_assistance_call_CTA',
    label: 'leads',
    value: 15,
    category: 'orders'
  })

  if (legacy) return <div className={`notSure ${top ? 'top' : ''}`}>
    <div className='row'>
        <div className='thick'><span className='bold'>{top ? 'Need expert advice?' : 'Still not sure?'}</span><br/> Call us or send us a request and we will be happy to help!</div>
        <div className="options">
          <Button className='btn-3 highLight' onClick={openQuote}><AiOutlineMail />Get a Quote</Button>
          <a className='btn-3 highLight button' href={phoneHref} onClick={trackCall}><AiOutlinePhone /> {phoneNumber}</a>
        </div>
    </div>
  </div>

  return <UiBoundary
    as='aside'
    className={`${styles.support} ${top ? styles.top : styles.catalogFooter}`.trim()}
    aria-labelledby={titleId}
  >
    <Container>
      <div className={styles.panel}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>{eyebrow || (top ? 'Expert guidance' : 'Personal rental assistance')}</span>
          <h3 id={titleId}>{title || (top ? 'Plan the right setup with an AV expert' : 'Need help choosing the right equipment?')}</h3>
          <p>{description || 'Call us for quick guidance or send a quote request with your event details.'}</p>
        </div>
        <div className={styles.actions}>
          <AudioAction className={styles.supportAction} mode='primary' fullWidth onClick={openQuote}>
            <AiOutlineMail aria-hidden='true' />{quoteLabel}
          </AudioAction>
          <AudioAction className={styles.supportAction} mode='secondary' fullWidth href={phoneHref} onClick={trackCall}>
            <AiOutlinePhone aria-hidden='true' />Call {phoneNumber}
          </AudioAction>
        </div>
      </div>
    </Container>
  </UiBoundary>
}

export default NotSure
